import React, { useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../components/apiconfig/api-config';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const Register = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    role: '',
    agreeTerms: false,
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const roles = ['Account', 'Purchase', 'Sale', 'Finance', 'Admin', 'Manager', 'Auditor', 'Backup', 'Developer'];

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (formData.password !== formData.confirmPassword) {
      return setError('Passwords do not match');
    }

    if (!formData.agreeTerms) {
      return setError('You must agree to the terms and conditions');
    }

    setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/api/auth/register`, {
        name: formData.name,
        email: formData.email,
        password: formData.password,
        role: formData.role,
      }, {
        withCredentials: true  // Send cookies with request
      });

      setSuccess('Registration successful!');
      setFormData({
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        role: '',
        agreeTerms: false,
      });
    } catch (err) {
      const message = err.response?.data?.error || 'Registration failed';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="w-full max-w-8xl bg-white rounded-lg shadow-md border border-gray-200">
        <div className="flex justify-between items-center border-b border-gray-100 bg-gray-50 px-6 py-3">
          <h2 className="text-lg font-bold mb-0 text-left">Create User Account <span className='ml-2 px-2 py-0.5 text-xs bg-blue-100 text-blue-700 rounded'>Admin Only</span></h2>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="flex items-center gap-1 text-[#10a5e9] border border-[#10a5e9] px-3 py-1 text-xs rounded font-medium hover:bg-[#eaf6fd]"
          >
            <FaArrowLeft />
            Back
          </button>
        </div>
        <form onSubmit={handleSubmit} className="px-6 pt-6 pb-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="name" className="block text-xs font-medium mb-1">Full Name</label>
              <input
                type="text"
                name="name"
                id="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter user's full name"
                required
                className="w-full border border-gray-300 px-4 py-2 text-sm bg-white focus:outline-none focus:border-[#10a5e9] rounded-none"
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-xs font-medium mb-1">Email Address</label>
              <input
                type="email"
                name="email"
                id="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter user's email"
                required
                className="w-full border border-gray-300 px-4 py-2 text-sm bg-white focus:outline-none focus:border-[#10a5e9] rounded-none"
              />
            </div>
            <div>
              <label htmlFor="password" className="block text-xs font-medium mb-1">Password</label>
              <input
                type="password"
                name="password"
                id="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter password"
                required
                className="w-full border border-gray-300 px-4 py-2 text-sm bg-white focus:outline-none focus:border-[#10a5e9] rounded-none"
              />
            </div>
            <div>
              <label htmlFor="confirmPassword" className="block text-xs font-medium mb-1">Confirm Password</label>
              <input
                type="password"
                name="confirmPassword"
                id="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                placeholder="Re-enter password"
                required
                className="w-full border border-gray-300 px-4 py-2 text-sm bg-white focus:outline-none focus:border-[#10a5e9] rounded-none"
              />
            </div>
            <div>
              <label htmlFor="role" className="block text-xs font-medium mb-1">Role</label>
              <select
                name="role"
                id="role"
                value={formData.role}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 px-4 py-2 text-sm bg-white focus:outline-none focus:border-[#10a5e9] rounded-none"
              >
                <option value="">Select a role</option>
                {roles.map((role) => (
                  <option key={role} value={role.toLowerCase()}>
                    {role}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex items-center mt-2">
              <input
                type="checkbox"
                name="agreeTerms"
                id="agreeTerms"
                checked={formData.agreeTerms}
                onChange={handleChange}
                className="mr-2"
              />
              <label htmlFor="agreeTerms" className="text-xs text-gray-700">
                I confirm the above details are correct
              </label>
            </div>
          </div>
          {error && <div className="mt-4 text-center text-sm text-red-600 w-full">{error}</div>}
          {success && <div className="mt-4 text-center text-sm text-green-600 w-full">{success}</div>}
          <div className="flex justify-end mt-6">
            <button type="submit" className="w-40 px-4 py-2 text-sm bg-[#10a5e9] text-white font-semibold tracking-wide rounded border border-[#10a5e9] hover:bg-[#0e8ac2] transition disabled:opacity-60" disabled={loading}>
              {loading ? 'Saving...' : 'Create User'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;
